import { useEffect, useState } from "react";
import { facturxPickClients, type FactureClient } from "../api/coffre";
import { IcoClose } from "./icons";

export function FactureClientSheet({
  filename,
  busy = false,
  banner = "",
  onPick,
  onClose,
}: {
  filename: string;
  busy?: boolean;
  banner?: string;
  onPick: (client: FactureClient) => void;
  onClose: () => void;
}) {
  const [q, setQ] = useState("");
  const [clients, setClients] = useState<FactureClient[]>([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    const t = window.setTimeout(() => {
      setLoading(true);
      facturxPickClients(q)
        .then((rows) => {
          if (!live) return;
          setClients(rows);
          setErr("");
        })
        .catch((e) => {
          if (!live) return;
          setClients([]);
          setErr(e instanceof Error ? e.message : "Clients Factures indisponibles.");
        })
        .finally(() => {
          if (live) setLoading(false);
        });
    }, q.trim() ? 220 : 0);
    return () => {
      live = false;
      window.clearTimeout(t);
    };
  }, [q]);

  return (
    <div className="sg-send-back" role="dialog" aria-label="Classer dans Factures">
      <div className="sg-send">
        <h2>Classer dans Factures</h2>
        <p className="sg-legal">PDF : {filename}</p>
        <input
          className="sg-input"
          value={q}
          placeholder="Nom, SIRET, société…"
          onChange={(e) => setQ(e.target.value)}
        />
        {err || banner ? <p className="sg-err">{banner || err}</p> : null}
        {loading && clients.length === 0 ? <p className="sg-legal">Chargement…</p> : null}
        <div className="sg-move-list">
          {clients.map((c) => (
            <button key={`${c.company_id}-${c.id}`} type="button" className="sg-btn ghost" disabled={busy} onClick={() => onPick(c)}>
              <strong>{c.name}</strong>
              <span className="sg-legal">
                {c.company_name}
                {c.siret ? ` · ${c.siret}` : ""}
              </span>
            </button>
          ))}
          {!loading && clients.length === 0 && !err ? <p className="sg-legal">Aucun client.</p> : null}
        </div>
        <p className="sg-legal">Le dossier signé se classe tout seul dans les documents du client.</p>
        <div className="sg-send__actions">
          <button type="button" className="sg-btn ghost" disabled={busy} onClick={onClose}>
            <IcoClose />
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}
